export default __webpack_public_path__ + "static/media/Ramesh_Flizone.eed289c6.jpg";